import orderprint from "../screens/orderprint";

export const apikey = "w9Ufg3LJ7IPG0WQme21nv3tQ";

export const apirouter = {
  // Authen
  login: "/api/v1/auth/login",
  profile: "/api/v1/auth/profile",

  //factory
  // factory: "/api/v1/master/machine/",
  // forklift: "/api/v1/master/forklift/",

  //scale
  scale: "/api/v1/master/weighitscal",

  //order
  acceptorder: "/api/v1/weighscale/acceptwork/",
  cancelorder: "/api/v1/product/cancelweightscal/",

  //weight
  weight: "/api/v1/forklift/senddataweight/",
  weightwip: "/api/v1/forklift/checkqrcodewip/",
  weightmaster: "/api/v1/weighscale/weightmaster/",
  machine_meter_master: "/api/v1/master/metermachine/",

  //location
  location: "/api/v1/master/storagelocation/",
  selectedlocation: "/api/v1/forklift/selectlocation/",
  enterlocation: "/api/v1/forklift/enterlocation/",

  //printlabel
  printlabel: "/api/v1/printlabel/",
  postprintlabel: "/api/v1/printlabel/",

  //orderprint
  orderprint: "/api/v1/printlabel/order/",
};

export default {
  apirouter,
  apikey,
};
